import React, { useState } from "react";
import { Typography, Button, Card, Checkbox, InputNumber } from "antd";

const { Title, Text } = Typography;

const RedemptionsSettings = () => {
  const [allowCartPoints, setAllowCartPoints] = useState(true);
  const [pointsRate, setPointsRate] = useState(1);
  const [dollarValue, setDollarValue] = useState(10);
  const [allowCheckoutPoints, setAllowCheckoutPoints] = useState(true);

  return (
    <div className="redemption-settings-container">
      <div className="redemption-header">
        <Title level={4} style={{ margin: 0, color: '#0f172a', fontWeight: 600 }}>Redemption Settings</Title>
        <Button type="primary" style={{ borderRadius: '6px', background: '#2563eb', fontWeight: 500 }}>
          Save
        </Button>
      </div>

      <Card className="redemption-card" bordered={false} bodyStyle={{ padding: '32px' }}>
        <div className="redemption-section">
          <Text className="redemption-label">Redemption Over Cart Subtotal</Text>
          <div className="redemption-input-group">
            <Checkbox checked={allowCartPoints} onChange={(e) => setAllowCartPoints(e.target.checked)}>
              <Text className="redemption-checkbox-text">Allow Customers to apply points during cart</Text>
            </Checkbox>
          </div>
        </div>

        <div className="redemption-section">
          <Text className="redemption-label">Conversion rate for cart Subtotal Redemption</Text>
          <div className="conversion-rate-group">
            <InputNumber min={1} value={pointsRate} onChange={setPointsRate} className="conversion-input" controls={false} />
            <Text className="conversion-text">Points = $</Text>
            <InputNumber min={0} value={dollarValue} onChange={setDollarValue} className="conversion-input" controls={false} />
          </div>
        </div>

        <div className="redemption-section" style={{ borderBottom: '1px solid #f1f5f9', paddingBottom: '32px', marginBottom: '8px' }}>
          <Text className="redemption-label">Enable Apply points during checkout</Text>
          <div className="redemption-input-group">
            <Checkbox checked={allowCheckoutPoints} onChange={(e) => setAllowCheckoutPoints(e.target.checked)}>
              <Text className="redemption-checkbox-text">Allow customers to apply points during checkout</Text>
            </Checkbox>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default RedemptionsSettings;
